module.exports = "{{#each columns}}\r\n<div class=\"grid-header-column\">\r\n    <div class=\"grid-header-column-content-view\"></div>\r\n    <div class=\"grid-header-dragger\"></div>\r\n</div>\r\n{{/each}}";


//////////////////
// WEBPACK FOOTER
// ../src/nativeGrid/templates/header.hbs
// module id = 713
// module chunks = 0